module.exports = __webpack_public_path__ + "assets/img/word.807e6906.svg";